<template>
  <div class="issues-app-main-footer">
    <div
      class="issues-app-main-footer__message"
      ref="issueNewMessage"
      contenteditable="true"
      @keyup="setMessage"
      placeholder="Напишите ваше сообщение..."
      @keypress.enter="sendMessage"
      @paste="onPaste"
    >
    </div>
    <div class="issues-app-main-footer__button issues-app-main-footer__button_file link-icon">
      <app-icon name="AttachFileIcon" />
      <input type="file" class="real-file-input" ref="files" multiple @change="filesAdded()">
      Прикрепить
    </div>
    <div class="issues-app-main-footer__button link-icon" @click="sendMessage">
      <app-icon name="SendIcon" />
      Отправить
    </div>

    <UploadFilesPopup ref="uploadFilePopup" @send="sendWithFiles" />
  </div>
</template>

<script>
import UploadFilesPopup from "../UploadFilesPopup";

export default {
  name:       "IssuesMainFooter",
  components: {
    UploadFilesPopup,
  },
  data() {
    return {
      message: "",
    };
  },
  methods:    {
    setMessage( e ) {
      const target = e.target;
      let value = target.textContent || target.innerText;
      value = value.replace(/\s{2,}/g, ' ');
      this.message = value.trim();
    },
    sendMessage( e ) {
      if (e.shiftKey) return;
      if (this.message.length === 0) return;
      this.$emit('send', { message: this.message });

      this.message = '';
      let input = this.$refs.issueNewMessage;
      while (input.firstChild)
        input.removeChild(input.firstChild);

      input.blur();
    },

    onPaste( e ) {
      const w = window;
      const d = document;
      e.preventDefault();
      if (e.clipboardData && e.clipboardData.getData) {
        const text = e.clipboardData.getData("text/plain");
        document.execCommand("insertHTML", false, text);
      } else if (w.clipboardData && w.clipboardData.getData) {
        const text = w.clipboardData.getData("Text");
        if (window.getSelection) {
          const selection = window.getSelection();
          if (selection.getRangeAt && selection.rangeCount) {
            const range = selection.getRangeAt(0);
            range.deleteContents();
            range.insertNode(document.createTextNode(text));
          }
        } else if (d.selection && d.selection.createRange) {
          d.selection.createRange().text = text;
        }
      }
    },

    sendWithFiles( body ) {
      this.$emit('send', body);

      this.message = '';
      let input = this.$refs.issueNewMessage;
      while (input.firstChild)
        input.removeChild(input.firstChild);

      input.blur();
    },
    filesAdded() {
      let files = this.$refs.files.files;
      this.$refs.uploadFilePopup.open(files, this.message);
    },
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/redesign/issues/variables";

.issues-app-main-footer {
  border-top: 1px solid $border-color;
  display: flex;
  align-items: flex-end;
  flex-shrink: 0;

  &__message {
    appearance: textfield;
    flex: 0 1 100%;
    display: inline-block;
    max-height: 200px;
    overflow-y: auto;
    line-height: 1.2;
    padding: 5px 10px;
    align-self: center;
    word-break: break-word;
    white-space: pre-wrap;
    border: none;

    &[placeholder]:empty:before {
      content: attr(placeholder);
      color: #555;
    }

    &[placeholder]:empty:focus:before {
      content: "";
    }
  }

  &__button {
    flex-shrink: 0;
    //width: 36px;
    height: 36px;
    border-top: 1px solid $border-color;
    margin-top: -1px;
    border-left: 1px solid $border-color;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px 8px;
    text-decoration: underline;
    overflow: hidden;

    &:hover {
      text-decoration: none;
    }

    &_file {
      position: relative;
      cursor: pointer;

      .real-file-input {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 200%;
        height: 200%;
        font-size: 0;
        opacity: 0;
        cursor: pointer;
      }
    }
  }
}
</style>
